import { useEffect, useState } from "react";
import { Table, Pagination, Select,  Button, Loader } from "@mantine/core";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import { isErrorObject } from "../utils/utils";
import ErrorHandler from "../services/ErrorHandler";
import { makeGetRequest } from "../services/httpHelper";
import { DatePickerInput } from "@mantine/dates";




interface TransactionEntry {
  type: string;
  amount: number;
  currency: string;
  account: {
    account_name: string;
    type: string;
  };
}

interface Transaction {
  id: number;
  description: string;
  type: string;
  date: string;
  entries: TransactionEntry[];
}

const TransactionStatement = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ type: "", startDate: "", endDate: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);



  useEffect(() => {
    fetchTransactions();
  }, [page, filters]);

  const fetchTransactions = async () => {
    const query = new URLSearchParams({ ...filters, page: page.toString(), pageSize: "10" }).toString();
    const response = await makeGetRequest(`transaction-statement?${query}`);    

    if (isErrorObject(response)) {
        setIsLoading(false);
        const errorMessage = ErrorHandler(response);
        //setError(errorMessage);
        console.log(errorMessage)
        setError('Failed to process beneficiary data'+errorMessage.message)
    } else {
        setTransactions(response.data.transactions);
        setTotalPages(response.data.totalPages);
        setIsLoading(false);

    }
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Transaction Statement", 14, 10);
    autoTable(doc,{
      head: [["Date", "Description", "Type", "Amount", "Currency", "Account"]],
      body: transactions.map((tx) => [
        tx.date,
        tx.description,
        tx.type,
        tx.entries.map((entry) => entry.amount).join(", "),
        tx.entries.map((entry) => entry.currency).join(", "),
        tx.entries.map((entry) => entry.account.account_name).join(", ")
      ]),
    });
    doc.save("transaction_statement.pdf");
  };

  return (
    <div>
        {isLoading && <Loader/>}
        {error && <p className="red">{error}</p>}
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <Select
          data={["", "Donation", "Withdrawal", "Commission", "Tip", "Expense", "Fee"]}
          placeholder="Transaction Type"
          onChange={(value) => setFilters({ ...filters, type: value || "" })}
        />

                    {/*<DatePickerInput
                        value={values.date_of_birth}
                        onChange={(date) => setValues({ ...values, date_of_birth: date })}
                        label="Date of Birth"
                        placeholder="Select Date of Birth"
                        maxDate={new Date()} 
                        minDate={new Date(1940, 0, 1)}
                        allowDeselect
                        defaultLevel="decade" // Start from decade view for easier navigation
                        popoverProps={{ withinPortal: true }} // Ensures the picker is not cut off in modals
                        clearable
                        error={errors.date_of_birth} 
                        />*/}
                        
        <DatePickerInput
          label="Start Date"
          onChange={(value) => setFilters({ ...filters, startDate: value?.toISOString() || "" })}
        />
        <DatePickerInput
          label="End Date"
          onChange={(value) => setFilters({ ...filters, endDate: value?.toISOString() || "" })}
        />
        <Button onClick={fetchTransactions}>Filter</Button>
      </div>

      <Table striped>
        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Currency</th>
            <th>Account</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx) => (
            <tr key={tx.id}>
              <td>{tx.date}</td>
              <td>{tx.description}</td>
              <td>{tx.type}</td>
              <td>{tx.entries.map((entry) => entry.amount).join(", ")}</td>
              <td>{tx.entries.map((entry) => entry.currency).join(", ")}</td>
              <td>{tx.entries.map((entry) => entry.account.account_name).join(", ")}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination total={totalPages} value={page} onChange={setPage} mt={10} />
      
      <div style={{ marginTop: "10px" }}>
        <Button onClick={exportPDF} style={{ marginRight: "10px" }}>Export PDF</Button>
        <CSVLink data={transactions} filename="transaction_statement.csv">
          <Button>Export CSV</Button>
        </CSVLink>
      </div>
    </div>
  );
};

export default TransactionStatement;
